import React from 'react';
import { observer } from 'mobx-react';

// import UpdateToAgentModal from './UpdateToAgent/UpdateToAgentModal';
// import AgentDetailModal from './AgentDetail/AgentDetailModal';
// import AgentDetailPayModal from './AgentDetail/AgentDetailPayModal';
import ChangeAgentModal from './ChangeAgent/ChangeAgentModal';
@observer
class UserModal extends React.Component {
  render() {
    return (
      <div>
        <ChangeAgentModal />
        {/*<UpdateToAgentModal />*/}
        {/*<AgentDetailModal />*/}
        {/*<AgentDetailPayModal />*/}
      </div>
    )
  }
}

export default UserModal;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Agent/AgentList/AgentModal.jsx